module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/investor-info.json
// module id = 345
// module chunks = 125233445572265